import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

const NavbarSkeleton = () => (
  <>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Skeleton
        variant="circle"
        width={24}
        height={24}
        style={{ margin: '0 12px' }}
      />
      <Skeleton variant="text" width={100} height={20} />
    </div>
    <Skeleton variant="text" width={280} height={28} />
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {[0, 1, 2, 3].map(i => (
        <Skeleton
          key={i}
          variant="circle"
          width={24}
          height={24}
          style={{ margin: '0 7px' }}
        />
      ))}
    </div>
  </>
)

export default NavbarSkeleton
